// extracted by mini-css-extract-plugin
export var activityContainer = "_li-0";
export var typingIndicatorContainer = "_li-1";
export var typingIndicatorDot = "_li-2";
export var wave = "_li-3";